import { AbstractSearchPaginationResultDto, PaginationDto } from '../../..';
import { UserSearchDto } from './user-search.dto';

export class UserSearchPaginationResultDto implements AbstractSearchPaginationResultDto<UserSearchDto> {
  pagination: PaginationDto;
  results: UserSearchDto[];
  totalElements: number;
}
